import React, { useState, useEffect } from "react";
import { Column, DataGrid, Button } from "devextreme-react/data-grid";
import CustomStore from "devextreme/data/custom_store";
import TextField from "@material-ui/core/TextField";
import Modal from "react-bootstrap/Modal";
import swal from "sweetalert";
import axios from "axios";
import { createStore } from "devextreme-aspnet-data-nojquery";
import Select from "react-select";
import Grid from "@material-ui/core/Grid";
import Container from "@material-ui/core/Container";
import "../../modal.css";
import { api_path } from "../../shared";
import DateBox from "devextreme-react/date-box";
const url = api_path + "/GET_SALES_ORDER_DETAILS.php";
const url_bse = api_path + "/GET_BSE_NO.php";
function JobManagmentMasterDetailView(props) {
  const now = new Date();
  const dateLabel = { "aria-label": "Date" };
  const dateTimeLabel = { "aria-label": "Date Time" };
  var date = new Date();
  const timeLabel = { "aria-label": "Time" };
  const [GET_CARRIER_CODE, SET_CARRIER_CODE] = useState(props.CARRIER_CODE);
  const [GET_SERVICES_CONTRACT, SET_SERVICES_CONTRACT] = useState(
    props.SERVICES_CONTRACT
  );
  const [GET_BULLET_CODE, SET_BULLET_CODE] = useState(props.BULLET_CODE);
  const GET_USER_ID = JSON.parse(localStorage.getItem("USER_ID"));
  const [GET_SCAC, SET_SCAC] = useState(props.SCAC);
  const [GET_ITEM_ID, SET_ITEM_ID] = useState("");
  const [GET_BOOKING_REF, SET_BOOKING_REF] = useState("");
  const [GET_BOOKING_NO, SET_BOOKING_NO] = useState("");
  const [GET_PROFORMA_ETD, SET_PROFORMA_ETD] = useState(null);
  const [GET_ETA, SET_ETA] = useState(null);
  const [GET_BSE_NO, SET_BSE_NO] = useState(null);
  const [GET_CTNR_CUTOFF_DATE, SET_CTNR_CUTOFF_DATE] = useState(null);
  const [GET_CTNR_CUTOFF_TIME, SET_CTNR_CUTOFF_TIME] = useState(null);
  const [GET_CTNR_CUTOFF_TIME_VALUE, SET_CTNR_CUTOFF_TIME_VALUE] =
    useState(null);
  const [GET_REMARK, SET_REMARK] = useState("");
  const [getOrderStatus, setOrderStatus] = useState([]);
  const [orderStatusList, setOrderStatusList] = useState([]);
  const [selectOrderStatus, setSelectOrderStatus] = useState([]);
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

const [dataSourceBse, setDataSourceBse] = useState(null);
const [showSMFModal, setShowSMFModal] = useState(false);
  const handleCloseSMFModal = () => setShowSMFModal(false);
  const handleShowSMFModal = () => setShowSMFModal(true);
  const [showEmailConfirmModal, setShowEmailConfirmModal] = useState(false);
  const [getHour, setHour] = useState([]);
  const [selectHour, setSelectHour] = useState();
  const [getMinute, setMinute] = useState([]);
  const [selectMinute, setSelectMinute] = useState();
  const state = {
    button: 1,
  };
  useEffect(() => {
    fetchOrderStatus();
    if (
      props.ORDER_STATUS == 6 ||
      props.ORDER_STATUS == 7 ||
      props.ORDER_STATUS == 8 ||
      props.ORDER_STATUS == 10 ||
      props.ORDER_STATUS == 11
    ) {
      setSMFEditButtonDisabled(true);
    } else {
      setSMFEditButtonDisabled(false);
    }

    if (props.ORDER_STATUS > 1) {
      setEditButtonDisabled(true);
    } else {
      setEditButtonDisabled(false);
    }
    // } else {
    //   setSMFEditButtonDisabled(false);
    //   setEditButtonDisabled(false);
    // }
  }, []);
  const [isEditButtonDisabled, setEditButtonDisabled] = useState(true);
  const [isSMFEditButtonDisabled, setSMFEditButtonDisabled] = useState(true);
  const [detailDataSource, setDetailDataSource] = useState(null);

  useEffect(() => {
    if (props.ORDER_ID) {
      const store = new CustomStore({
        key: "ORDER_ID",
        load: () => {
          return fetch(`${url}?ORDER_ID=${props.ORDER_ID}`)
            .then((res) => res.json())
            .catch(() => []);
        },
      });
      setDetailDataSource(store);
    }
  }, [props.ORDER_ID]);
  // const dataSource = createStore({
  //   key: "ORDER_ID",
  //   loadUrl: `${url}`,
  //   loadParams: { ORDER_ID: props.ORDER_ID },
  // });
  // const dataSourceBse = createStore({
  //   key: "DOCNO",
  //   loadUrl: `${url_bse}`,
  //   loadParams: { BOOKINGNO: GET_BOOKING_NO },
  // });
  const [errors, setErrors] = useState({});
  const validateForm = () => {
    const errors = {};
    if (GET_BOOKING_NO.trim()) {
      if (!GET_PROFORMA_ETD) {
        errors.etd = "Proforma etd is required";
      }
      if (!GET_CTNR_CUTOFF_DATE) {
        errors.cutoffdate = "Cut off date is required";
      }
      if (getHour.length === 0) {
        errors.cutofftime = "Cut off time is required";
      }
      if (getMinute.length === 0) {
        errors.cutofftime = "Cut off time is required";
      }
    }
    return errors;
  };
  function updateBookingRef(
    ORDER_ITEM_ID,
    CARRIER_CODE,
    SERVICES_CONTRACT,
    BULLET_CODE,
    SCAC,
    BOOKING_REF,
    BOOKING_NO,
    BSE_NO,
    PROFORMA_ETD,
    ETA,
    ORDER_ITEM_STATUS,
    ORDER_ITEM_NOTE,
    ORDER_ID,
    ORDER_STATUS,
    USER_ID
  ) {
    const newErrors = validateForm();
    setErrors(newErrors);
    if (Object.keys(newErrors).length > 0) {
      //alert("Invalid")
    } else {
      let cutoffTimeStr;
      if (
        !GET_CTNR_CUTOFF_DATE &&
        getHour.length === 0 &&
        getMinute.length === 0
      ) {
        cutoffTimeStr = "";
      } else {
        cutoffTimeStr =
          GET_CTNR_CUTOFF_DATE + " " + getHour.label + ":" + getMinute.label;
      }
      var data = {
        ORDER_ID: ORDER_ID,
        ORDER_ITEM_ID: ORDER_ITEM_ID,
        CARRIER_CODE: CARRIER_CODE,
        SERVICES_CONTRACT: SERVICES_CONTRACT,
        BULLET_CODE: BULLET_CODE,
        SCAC: SCAC,
        ORDER_ITEM_STATUS: ORDER_ITEM_STATUS,
        BOOKING_REF: BOOKING_REF,
        BOOKING_NO: BOOKING_NO,
        BSE_NO: BSE_NO,
        PROFORMA_ETD: PROFORMA_ETD,
        CTNR_CUTOFF_DATE: GET_CTNR_CUTOFF_DATE,
        CTNR_CUTOFF_TIME: cutoffTimeStr,
        ETA: ETA,
        ORDER_ITEM_NOTE: ORDER_ITEM_NOTE,
        USER_ID: USER_ID,
      };
      fetch(api_path + "/TS_SALES_ORDER_UPDATE_STATUS_ITEM.php", {
        method: "POST",
        headers: {
          Accept: "application/form-data",
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      })
        .then((res) => res.json())
        .then((result) => {
          if (result["status"] == "200") {
            swal("Done.", "Save data successfully.", "success", {
              buttons: true,
              timer: 5000,
            }).then(function () {
              props.sendDataToParent();
              handleClose();
              //window.location.reload();
              const url =
                api_path +
                "/SENDMAIL_SALESORDER.php?order_id=" +
                ORDER_ID +
                "&flag=updatebooking&order_status=" +
                ORDER_STATUS;
              axios
                .get(url)
                .then((response) => {
                  // handle success
                  console.log(result["message"]);
                })
                .then((data) => {
                  console.log(data);
                  // Handle data
                })
                .catch((error) => {
                  // handle errors
                });
            });
          } else {
            swal("Sorry", result["message"], "error", {
              buttons: true,
              timer: 5000,
            });
            SET_BOOKING_NO("");
          }
        });
    }
  }
  const validateForm2 = () => {
    const errors = {};
    if (!GET_BSE_NO) {
      errors.bse = "Please select BSE";
    }
    return errors;
  };
  function updateBSE_NO(
    ORDER_ID,
    ORDER_ITEM_ID,
    USER_ID,
    BSE_NO,
    ORDER_STATUS_ID,
    REMARK
  ) {
    if (state.button === 1) {
      //update bse
      const newErrors = validateForm2();
      setErrors(newErrors);
      if (Object.keys(newErrors).length > 0) {
        //alert("Invalid")
      } else {
        var data = {
          ORDER_ID: ORDER_ID,
          ORDER_ITEM_ID: ORDER_ITEM_ID,
          USER_ID: USER_ID,
          BSE_NO: BSE_NO,
          REMARK: "",
        };
        fetch(api_path + "/SALES_ORDER_UpdateSalesOrderBSECreated.php", {
          method: "POST",
          headers: {
            Accept: "application/form-data",
            "Content-Type": "application/json",
          },
          body: JSON.stringify(data),
        })
          .then((res) => res.json())
          .then((result) => {
            if (result["status"] == "200") {
              swal("Done.", "Save data successfully.", "success", {
                buttons: true,
                timer: 5000,
              }).then(function () {
                props.sendDataToParent();
                handleClose();
                const url =
                  api_path +
                  "/SENDMAIL_SALESORDER.php?order_id=" +
                  ORDER_ID +
                  "&flag=updatebooking&order_status=" +
                  ORDER_STATUS_ID;
                axios
                  .get(url)
                  .then((response) => {
                    // handle success
                    console.log(result["message"]);
                  })
                  .then((data) => {
                    console.log(data);
                    // Handle data
                  })
                  .catch((error) => {
                    // handle errors
                  });

                ////////////////////////////////////////////////////
              });
            } else {
              swal("Sorry", result["message"], "error", {
                buttons: true,
                timer: 5000,
              });
            }
          });
      }
    }
    if (state.button === 2) {
      //clear bse
      swal({
        title: "Are you sure to clear bse no?",
        text: "",
        icon: "info",
        dangerMode: false,
        buttons: true,
      }).then((isConfirm) => {
        if (isConfirm) {
          SET_BSE_NO("");
          var data = {
            ORDER_ID: ORDER_ID,
            ORDER_ITEM_ID: ORDER_ITEM_ID,
            USER_ID: USER_ID,
            BSE_NO: "",
            REMARK: "",
          };
          fetch(api_path + "/SALES_ORDER_UpdateSalesOrderBSECreated.php", {
            method: "POST",
            headers: {
              Accept: "application/form-data",
              "Content-Type": "application/json",
            },
            body: JSON.stringify(data),
          })
            .then((res) => res.json())
            .then((result) => {
              if (result["status"] == "200") {
                swal("Done.", "Save data successfully.", "success", {
                  buttons: true,
                  timer: 5000,
                }).then(function () {
                  props.sendDataToParent();
                  handleClose();
                  const url =
                    api_path +
                    "/SENDMAIL_SALESORDER.php?order_id=" +
                    ORDER_ID +
                    "&flag=updatebooking&order_status=" +
                    ORDER_STATUS_ID;
                  axios
                    .get(url)
                    .then((response) => {
                      // handle success
                      console.log(result["message"]);
                    })
                    .then((data) => {
                      console.log(data);
                      // Handle data
                    })
                    .catch((error) => {
                      // handle errors
                    });

                  ////////////////////////////////////////////////////
                });
              } else {
                swal("Sorry", result["message"], "error", {
                  buttons: true,
                  timer: 5000,
                });
              }
            });
        }
      });
    }
  }
  //////////////////////////////
  function onSelectBseButtonClick(e) {
    const dataRow = e.row && e.row.data;
    SET_BSE_NO(dataRow.DOCNO);
  }
  function onSMFEditButtonClick(e) {
    const dataRow = e.row && e.row.data;
    const bookingNo = dataRow?.BOOKINGNO;
    if (!bookingNo) return;
    const store = createStore({
      key: "DOCNO",
      loadUrl: `${url_bse}`,
      loadParams: { BOOKINGNO: bookingNo },
    });

    setDataSourceBse(store); // <-- set ลงใน state
    setShowSMFModal(true); // <-- เปิด modal
    SET_ITEM_ID(dataRow.SALES_ORDER_ITEM_ID);
    SET_BOOKING_NO(dataRow.BOOKINGNO);
    SET_BSE_NO(dataRow.SMF_REFNO);
  }
  function onEditButtonClick(e) {
    const dataRow = e.row && e.row.data;
    SET_ITEM_ID(dataRow.SALES_ORDER_ITEM_ID);
    SET_BOOKING_NO(dataRow.BOOKINGNO);
    SET_BOOKING_REF(dataRow.BOOKINGREF);
    SET_BSE_NO(dataRow.SMF_REFNO);
    SET_PROFORMA_ETD(dataRow.PROFORMA_ETD);
    SET_CTNR_CUTOFF_DATE(dataRow.CONTAINER_CUTOFF_DATE);
    if (
      dataRow.CONTAINER_CUTOFF_TIME !== null &&
      dataRow.CONTAINER_CUTOFF_TIME !== undefined &&
      dataRow.CONTAINER_CUTOFF_TIME !== ""
    ) {
      let dateStr = new Date(dataRow.CONTAINER_CUTOFF_TIME);
      setSelectHour(dateStr.getHours());
      setHour({
        value: dateStr.getHours(),
        label: dateStr.getHours(),
      });
      setSelectMinute(dateStr.getMinutes());
      setMinute({
        value: dateStr.getMinutes(),
        label: dateStr.getMinutes(),
      });
    } else {
      setSelectHour([]);
      setHour([]);
      setSelectMinute([]);
      setMinute([]);
    }

    SET_REMARK(dataRow.REMARK);
    setSelectOrderStatus(dataRow.ACTIVE_STATUS);
    setOrderStatus({
      INQUIRY_MASTER_VALUE: dataRow.ACTIVE_STATUS,
      INQUIRY_MASTER_EN: dataRow.STATUS_NAME,
    });
    setShow(true);
  }
  const fetchOrderStatus = () => {
    axios
      .get(api_path + `/MS_INQUIRY_MASTER.php?type=ORDER_ITEM_STATUS`)
      .then((response) => {
        setOrderStatusList(response.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const handleOrderStatusChange = (obj) => {
    setSelectOrderStatus(obj.INQUIRY_MASTER_VALUE);
    setOrderStatus({
      INQUIRY_MASTER_VALUE: obj.INQUIRY_MASTER_VALUE,
      INQUIRY_MASTER_EN: obj.INQUIRY_MASTER_EN,
    });
  };
  const cellPrepared = (e) => {
    if (e.rowType === "data") {
      if (e.column.dataField === "STATUS_NAME" && e.data.ACTIVE_STATUS == 1) {
        e.cellElement.innerHTML =
          "<p style='color: GREEN;text-align:left;'>" +
          e.data.STATUS_NAME +
          "</p>";
      } else if (
        e.column.dataField === "STATUS_NAME" &&
        e.data.ACTIVE_STATUS == 100
      ) {
        e.cellElement.innerHTML =
          "<p style='color: GREEN;text-align:left;'>" +
          e.data.STATUS_NAME +
          "</p>";
      } else if (
        e.column.dataField === "STATUS_NAME" &&
        e.data.ACTIVE_STATUS > 1
      ) {
        e.cellElement.innerHTML =
          "<p style='color: RED;text-align:left;'>" +
          e.data.STATUS_NAME +
          "</p>";
      } else if (
        e.column.dataField === "STATUS_NAME" &&
        e.data.ACTIVE_STATUS == 0
      ) {
        e.cellElement.innerHTML =
          "<p style='color: RED;text-align:left;'>" +
          e.data.STATUS_NAME +
          "</p>";
      } else {
      }
    }
  };

  const isSMFEdit = (SMF_REFNO) => {
    if (SMF_REFNO == "" || SMF_REFNO === null || SMF_REFNO === undefined) {
      return true;
    } else {
      return false;
    }
  };
  const isSMFEditIconVisible = (e) => isSMFEdit(e.row.data.SMF_REFNO);

  const isViewBookingIconVisible = (e) =>
    isViewPdf(e.row.data.SMF_REFNO, props.ORDER_STATUS);
  const isViewPdf = (SMF_REFNO, ORDER_STATUS) => {
    if (
      ORDER_STATUS == 7 ||
      ORDER_STATUS == 8 ||
      ORDER_STATUS == 10 ||
      ORDER_STATUS == 11
    ) {
      if (SMF_REFNO == "" || SMF_REFNO === null || SMF_REFNO === undefined) {
        return false;
      } else {
        return true;
      }
    } else {
      return false;
    }
  };
  const [hasSmfRefNo, setHasSmfRefNo] = useState(false);
  const handleContentReady = (e) => {
    const visibleRows = e.component.getVisibleRows();
    const rows = visibleRows.map((row) => row.data);

    const has = rows.some(
      (row) => row.SMF_REFNO && row.SMF_REFNO.trim() !== ""
    );

    setHasSmfRefNo(has);
  };
  const isBookingEditIconVisible = (e) =>
    isBookingNoEdit(
      e.row.data.BOOKINGNO,
      e.row.data.SMF_REFNO,
      props.ORDER_STATUS
    );
  const isBookingNoEdit = (BOOKINGNO, SMF_REFNO, ORDERSTATUS) => {
    if (BOOKINGNO == "" || BOOKINGNO === null || BOOKINGNO === undefined) {
      return false;
    } else {
      if (ORDERSTATUS < 6) {
        return false;
      } else if (ORDERSTATUS > 6) {
        //bse create
        if (SMF_REFNO === null || SMF_REFNO === undefined) {
          return false;
        } else {
          return true;
        }
      } else {
        return true;
      }
    }
  };

  const isBSENOEdit = (SMF_REFNO, ORDER_STATUS) => {
    if (ORDER_STATUS < 11) {
      if (SMF_REFNO == "" || SMF_REFNO === null || SMF_REFNO === undefined) {
        return false;
      } else {
        return true;
      }
    } else {
      return false;
    }
  };
  const isSendConfirmIconVisible = (e) =>
    isBSENOEdit(e.row.data.SMF_REFNO, props.ORDER_STATUS);

  const isEdit = (status) =>
    status && ["0"].indexOf(status.trim().toUpperCase()) >= 0;
  const isEditIconVisible = (e) => !isEdit(props.ORDER_STATUS);
  const onValueChangedDate = React.useCallback((e) => {
    if (e.value) {
      const date1 = new Date(e.value);
      const formattedDate1 = date1
        .toLocaleDateString("en-GB", {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
        })
        .split("/")
        .reverse()
        .join("-");
      SET_PROFORMA_ETD(formattedDate1);
    } else {
      SET_PROFORMA_ETD(null);
    }
  }, []);

  const onValueChangedCutoffDate = React.useCallback((e) => {
    if (e.value) {
      const date2 = new Date(e.value);
      const getDate = date2
        .toLocaleDateString("en-GB", {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
        })
        .split("/")
        .reverse()
        .join("-");
      SET_CTNR_CUTOFF_DATE(getDate);
    } else {
      SET_CTNR_CUTOFF_DATE(null);
    }
  }, []);
  const onValueChangedDateETA = React.useCallback((e) => {
    if (e.value) {
      const date3 = new Date(e.value);
      const formattedDate3 = date3
        .toLocaleDateString("en-GB", {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
        })
        .split("/")
        .reverse()
        .join("-");
      SET_ETA(formattedDate3);
    } else {
      SET_ETA(null);
    }
  }, []);
  const hourList = [
    { value: "00", label: "00" },
    { value: "01", label: "01" },
    { value: "02", label: "02" },
    { value: "03", label: "03" },
    { value: "04", label: "04" },
    { value: "05", label: "05" },
    { value: "06", label: "06" },
    { value: "07", label: "07" },
    { value: "08", label: "08" },
    { value: "09", label: "09" },
    { value: "10", label: "10" },
    { value: "11", label: "11" },
    { value: "13", label: "13" },
    { value: "14", label: "14" },
    { value: "15", label: "15" },
    { value: "16", label: "16" },
    { value: "17", label: "17" },
    { value: "18", label: "18" },
    { value: "19", label: "19" },
    { value: "20", label: "20" },
    { value: "21", label: "21" },
    { value: "22", label: "22" },
    { value: "23", label: "23" },
  ];
  const minuteList = [
    { value: "00", label: "00" },
    { value: "01", label: "01" },
    { value: "02", label: "02" },
    { value: "03", label: "03" },
    { value: "04", label: "04" },
    { value: "05", label: "05" },
    { value: "06", label: "06" },
    { value: "07", label: "07" },
    { value: "08", label: "08" },
    { value: "09", label: "09" },
    { value: "10", label: "10" },
    { value: "11", label: "11" },
    { value: "13", label: "13" },
    { value: "14", label: "14" },
    { value: "15", label: "15" },
    { value: "16", label: "16" },
    { value: "17", label: "17" },
    { value: "18", label: "18" },
    { value: "19", label: "19" },
    { value: "20", label: "20" },
    { value: "21", label: "21" },
    { value: "22", label: "22" },
    { value: "23", label: "23" },
    { value: "24", label: "24" },
    { value: "25", label: "25" },
    { value: "26", label: "26" },
    { value: "27", label: "27" },
    { value: "28", label: "28" },
    { value: "29", label: "29" },
    { value: "30", label: "30" },
    { value: "31", label: "31" },
    { value: "32", label: "32" },
    { value: "33", label: "33" },
    { value: "34", label: "34" },
    { value: "35", label: "35" },
    { value: "36", label: "36" },
    { value: "37", label: "37" },
    { value: "38", label: "38" },
    { value: "39", label: "39" },
    { value: "40", label: "40" },
    { value: "41", label: "41" },
    { value: "42", label: "42" },
    { value: "43", label: "43" },
    { value: "44", label: "44" },
    { value: "45", label: "45" },
    { value: "46", label: "46" },
    { value: "47", label: "47" },
    { value: "48", label: "48" },
    { value: "49", label: "49" },
    { value: "50", label: "50" },
    { value: "51", label: "51" },
    { value: "52", label: "52" },
    { value: "53", label: "53" },
    { value: "54", label: "54" },
    { value: "55", label: "55" },
    { value: "56", label: "56" },
    { value: "57", label: "57" },
    { value: "58", label: "58" },
    { value: "59", label: "59" },
  ];
  const handleHourChange = (obj) => {
    if (obj) {
      setSelectHour(obj.value);
      setHour({ value: obj.value, label: obj.label });
    } else {
      setSelectHour([]);
      setHour([]);
    }
  };
  const handleMinuteChange = (obj) => {
    if (obj) {
      setSelectMinute(obj.value);
      setMinute({ value: obj.value, label: obj.label });
    } else {
      setSelectMinute([]);
      setMinute([]);
    }
  };

  const onSendEmailClickButtonClick = (e) => {
    const dataRow = e.row && e.row.data;
    window.open(
      "/s-crm/BookingConfirmation?doc=" +
        dataRow.SMF_REFNO +
        "&order_id=" +
        props.ORDER_ID +
        "&item_id=" +
        dataRow.SALES_ORDER_ITEM_ID +
        "&shpr=" +
        props.SHIPPER_CODE +
        "&cnee=" +
        props.CNEE_CODE +
        "&view=0",
      "_blank"
    );
  };
  const onViewPdfClickButtonClick = (e) => {
    const dataRow = e.row && e.row.data;
    window.open(
      "https://apps.sinologistics.co.th/api/SalesOrderConfirmBookingDetail.php?DOCNO=" +
        dataRow.SMF_REFNO +
        "&order_id=" +
        props.ORDER_ID +
        "&item_id=" +
        dataRow.SALES_ORDER_ITEM_ID +
        "&shpr=" +
        props.SHIPPER_CODE +
        "&cnee=" +
        props.CNEE_CODE +
        "&view=1",
      "_blank"
    );
  };
  return (
    <>
      <DataGrid
        dataSource={detailDataSource}
        showBorders={false}
        keyExpr="ORDER_ID"
        repaintChangesOnly={true}
        onCellPrepared={cellPrepared}
        onContentReady={handleContentReady}
      >
        <Column dataField="SALES_ORDER_ITEM_ID" caption="ID" visible={false} />
        <Column dataField="CARRIER_CODE" caption="CARRIER" width={100} />
        <Column dataField="SERVICES_CONTRACT" caption="S/C" width={150} />
        <Column dataField="BULLET_CODE" caption="BULLET CODE" width={150} />
        <Column dataField="ACTIVE_STATUS" visible={false} />
        <Column
          dataField="STATUS_NAME"
          caption="ITEM STATUS"
          cssClass="gray"
          width={200}
        />
        <Column dataField="REMARK" caption="REMARK" cssClass="gray" />
        <Column
          dataField="BOOKINGREF"
          caption="Book Ref"
          cssClass="gray"
          width={100}
        />
        <Column
          dataField="BOOKINGNO"
          caption="Book No."
          cssClass="gray"
          width={100}
        />
        <Column
          dataField="PROFORMA_ETD"
          caption="PROFORMA ETD"
          cssClass="gray"
          width={120}
        />
        <Column
          dataField="CONTAINER_CUTOFF_DATE"
          caption="CUTOFF DATE"
          cssClass="gray"
          width={120}
          visible={false}
        />
        <Column
          dataField="CONTAINER_CUTOFF_TIME"
          caption="CUTOFF"
          cssClass="gray"
          width={150}
        />
        <Column dataField="ETA" caption="ETA" cssClass="gray" width={120} />
        {/* {!isSMFEditButtonDisabled && ( */}
        <Column
          dataField="SMF_REFNO"
          caption="SMF REFNO"
          cssClass="gray"
          width={100}
        />
        {/* )} */}
        {isSMFEditButtonDisabled && (
          <Column type="buttons" caption="BSE NO" width="5%">
            <Button
              icon="search"
              onClick={onSMFEditButtonClick}
              hint="Click to search bse"
              visible={(e) => {
                const currentRow = e.row?.data;
                const hasSmfRefNo = e.component
                  .getVisibleRows()
                  .some((row) => row.data?.SMF_REFNO?.trim());

                // ถ้าแถวนี้มี SMF_REFNO → แสดงเสมอ
                if (currentRow?.SMF_REFNO?.trim()) return true;

                // ถ้าแถวอื่นมี SMF_REFNO → ซ่อน
                if (hasSmfRefNo) return false;

                // เงื่อนไข custom เพิ่มเติม
                return isBookingNoEdit(
                  currentRow?.BOOKINGNO,
                  currentRow?.SMF_REFNO,
                  props.ORDER_STATUS
                );
              }}
            />
            <Button
              icon="message"
              onClick={onSendEmailClickButtonClick}
              visible={isSendConfirmIconVisible}
              hint="Click to send Email Confirm"
            />
            <Button
              icon="pdffile"
              onClick={onViewPdfClickButtonClick}
              visible={isViewBookingIconVisible}
              hint="Click to view pdf file"
            />
          </Column>
        )}
        <Column type="buttons" caption="Edit" width="5%">
          {isEditButtonDisabled && (
            <Button
              icon="edit"
              onClick={onEditButtonClick}
              visible={isEditIconVisible}
              hint="Click to update booking details"
            />
          )}
        </Column>
      </DataGrid>
      <label className="head3">Volume</label>
      <table border="1" width="50%">
        <tr className="box">
          <td width="80" colSpan="2" align="center">
            20'
          </td>

          <td width="80" colSpan="2" align="center">
            40'
          </td>

          <td width="80" colSpan="2" align="center">
            40HC
          </td>

          <td width="80" colSpan="2" align="center">
            45'
          </td>

          <td width="80" align="center">
            GW
          </td>

          <td align="center">BOOK PRIORITY</td>

          <td align="center">WAITING SALES TO CONFIRM</td>
        </tr>
        <tr>
          <td width="40" align="center">
            {props.CNT20 == "0" ? "-" : props.CNT20}
          </td>
          <td width="40" align="center">
            {props.TYPE20}
          </td>
          <td width="40" align="center">
            {props.CNT40 == "0" ? "-" : props.CNT40}
          </td>
          <td width="40" align="center">
            {props.TYPE40}
          </td>
          <td width="40" align="center">
            {props.CNT40HQ == "0" ? "-" : props.CNT40HQ}
          </td>
          <td width="40" align="center">
            {props.TYPE40HQ}
          </td>
          <td width="40" align="center">
            {props.CNT45 == "0" ? "-" : props.CNT45}
          </td>
          <td width="40" align="center">
            {props.TYPE45}
          </td>

          <td align="center">{props.GW}</td>

          <td align="center">{props.BOOK_PRIORITY}</td>
          <td align="center">{props.WAITING_FLAG == "Y" ? "YES" : "NO"}</td>
        </tr>
      </table>

      {/* Modal update bse */}
      <Modal
        className="modal"
        show={showSMFModal}
        onHide={handleCloseSMFModal}
        backdrop="static"
        keyboard={false}
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>SEARCH BSE</Modal.Title>
        </Modal.Header>

        <Modal.Body className="grid-example">
          {/* Search BSE */}
          <DataGrid
            dataSource={dataSourceBse}
            showBorders={false}
            keyExpr="DOCNO"
            onCellPrepared={cellPrepared}
          >
            <Column dataField="DOCNO" caption="BSE NO" width="80%" />
            <Column type="buttons" caption="Select" width="10%">
              {isEditButtonDisabled && (
                <Button
                  icon="add"
                  onClick={onSelectBseButtonClick}
                  hint="Select BSE"
                />
              )}
            </Column>
          </DataGrid>
          <form
            onSubmit={(e) => {
              e.preventDefault();
              updateBSE_NO(
                props.ORDER_ID,
                GET_ITEM_ID,
                GET_USER_ID,
                GET_BSE_NO,
                "7",
                GET_REMARK
              );
            }}
            id="editmodal"
            className=""
          >
            <Grid container spacing={2}>
              <Grid item xs={12} sm={12}></Grid>
              <Grid item xs={12} sm={6}>
                <label>
                  Book No:
                  <input
                    type="text"
                    value={GET_BOOKING_NO}
                    onChange={(e) => SET_BOOKING_NO(e.target.value)}
                    disabled="true"
                  />
                </label>
              </Grid>
              <Grid item xs={12} sm={6}>
                <label>
                  BSE No:
                  <input
                    type="text"
                    value={GET_BSE_NO}
                    onChange={(e) => SET_BSE_NO(e.target.value)}
                    disabled="true"
                  />
                </label>
                {GET_BSE_NO && (
                  <button
                    className="btn btn-primary"
                    form="editmodal"
                    onClick={() => (state.button = 2)}
                  >
                    Clear
                  </button>
                )}
                {errors.bse && (
                  <span className="error-message">{errors.bse}</span>
                )}
              </Grid>
            </Grid>
          </form>
        </Modal.Body>

        <Modal.Footer>
          <button className="btn btn-secondary" onClick={handleCloseSMFModal}>
            Close
          </button>
          <button
            className="btn btn-primary"
            form="editmodal"
            onClick={() => (state.button = 1)}
          >
            Save
          </button>
        </Modal.Footer>
      </Modal>
      {/* modal update job */}
      <Modal
        className="modal"
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>Update Job</Modal.Title>
        </Modal.Header>

        <Modal.Body className="grid-example">
          <form
            onSubmit={(e) => {
              e.preventDefault();
              updateBookingRef(
                GET_ITEM_ID,
                GET_CARRIER_CODE,
                GET_SERVICES_CONTRACT,
                GET_BULLET_CODE,
                GET_SCAC,
                GET_BOOKING_REF,
                GET_BOOKING_NO,
                GET_BSE_NO,
                GET_PROFORMA_ETD,
                GET_ETA,
                selectOrderStatus,
                GET_REMARK,
                props.ORDER_ID,
                "4",
                GET_USER_ID
              );
            }}
            id="editmodal"
            className=""
          >
            <input
              type="hidden"
              value={GET_ITEM_ID}
              onChange={(e) => SET_ITEM_ID(e.target.value)}
            />
            <Container>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                  <label>Book Ref:</label>
                  <TextField
                    size="small"
                    name="GET_BOOKING_REF"
                    variant="outlined"
                    fullWidth
                    id="GET_BOOKING_REF"
                    value={GET_BOOKING_REF}
                    onChange={(e) => SET_BOOKING_REF(e.target.value)}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <label>Book No: </label>

                  <TextField
                    size="small"
                    name="GET_BOOKING_NO"
                    variant="outlined"
                    fullWidth
                    id="GET_BOOKING_NO"
                    value={GET_BOOKING_NO}
                    onChange={(e) => SET_BOOKING_NO(e.target.value)}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <label>
                    PROFORMA ETD:
                    <DateBox
                      styles={{
                        menu: (provided) => ({ ...provided, zIndex: 9999 }),
                      }}
                      inputAttr={dateLabel}
                      type="date"
                      displayFormat="dd/MM/yyyy"
                      value={GET_PROFORMA_ETD}
                      onValueChanged={onValueChangedDate}
                    />
                  </label>
                  {errors.etd && (
                    <span className="error-message">{errors.etd}</span>
                  )}
                </Grid>
                <Grid item xs={12} sm={6}>
                  <label>
                    ETA:
                    <DateBox
                      styles={{
                        menu: (provided) => ({ ...provided, zIndex: 9999 }),
                      }}
                      inputAttr={dateLabel}
                      type="date"
                      displayFormat="dd/MM/yyyy"
                      value={GET_ETA}
                      onValueChanged={onValueChangedDateETA}
                    />
                  </label>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <label>
                    CUTOFF DATE:
                    <DateBox
                      styles={{
                        menu: (provided) => ({ ...provided, zIndex: 9999 }),
                      }}
                      value={GET_CTNR_CUTOFF_DATE}
                      inputAttr={dateLabel}
                      type="date"
                      displayFormat="dd/MM/yyyy"
                      onValueChanged={onValueChangedCutoffDate}
                    />
                  </label>
                  {errors.cutoffdate && (
                    <span className="error-message">{errors.cutoffdate}</span>
                  )}
                </Grid>
                <Grid item xs={12} sm={3}>
                  <label>
                    TIME:
                    <Select
                      className="multiselect2"
                      placeholder="Select"
                      value={getHour}
                      options={hourList}
                      onChange={handleHourChange}
                    />
                  </label>
                  {errors.cutofftime && (
                    <span className="error-message">{errors.cutofftime}</span>
                  )}
                </Grid>
                <Grid item xs={12} sm={3}>
                  <label>
                    &nbsp;
                    <Select
                      className="multiselect2"
                      placeholder="Select"
                      value={getMinute}
                      options={minuteList}
                      onChange={handleMinuteChange}
                    />
                  </label>
                </Grid>
                <Grid item xs={12} sm={6}>
                  {" "}
                </Grid>
              </Grid>
              <Grid item xs={12} sm={6}>
                <label>
                  ITEM STATUS:
                  <Select
                    styles={{
                      menu: (provided) => ({ ...provided, zIndex: 9999 }),
                    }}
                    placeholder="Select..."
                    value={getOrderStatus}
                    options={orderStatusList}
                    onChange={handleOrderStatusChange}
                    getOptionLabel={(x) => x.INQUIRY_MASTER_EN}
                    getOptionValue={(x) => x.INQUIRY_MASTER_VALUE}
                    required
                  />
                </label>
              </Grid>
              <Grid item xs={12} sm={6}>
                &nbsp;
              </Grid>
              <Grid item xs={12} sm={12}>
                <label>REMARK: </label>
                <TextField
                  size="small"
                  name="GET_REMARK"
                  variant="outlined"
                  fullWidth
                  id="GET_REMARK"
                  value={GET_REMARK}
                  onChange={(e) => SET_REMARK(e.target.value)}
                />
              </Grid>
            </Container>
          </form>
        </Modal.Body>

        <Modal.Footer>
          <button className="btn btn-secondary" onClick={handleClose}>
            Close
          </button>
          <button className="btn btn-primary" form="editmodal">
            Save
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
export default JobManagmentMasterDetailView;
